module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Author’s preface")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("The book of Psalms is the heart of the Old Testament. Athanasius, the important fourth-century Church Father, called the Psalms ‘an epitome of the whole Scriptures’. In the same century, Basil, the Bishop of Caesarea, pointed out that this collection of poems presents ‘a compendium of all theology’, and Martin Luther, the sixteenth-century Reformer, called the book of Psalms ‘a little Bible, and the summary of the Old Testament’.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Indeed, the Psalms are not only the heart of the Old Testament; they are a pivotal witness and anticipation of Jesus Christ, and thus a perfect illustration of Augustine’s statement that ‘the New Testa ment is in the Old concealed, and the Old is in the New revealed’. Jesus made this clear when he told his disciples that the Psalms spoke of him (Luke 24:44).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("It is crucial to note that the book of Psalms is not a theological textbook, but rather the libretto of the most vibrant worship imaginable. The book of Psalms does not only want to inform our intellect, but to stimulate our imagination, arouse our emotions and stir us on to holy thoughts and actions.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("I begin by acknowledging the debt that I owe to Derek Kidner (1913–2008), the author of the Psalms commentary in the first edition of the Tyndale Old Testament Commentary series. I never met him, but he was the external reader of one of my very first books, "), _c('i', [_vm._v("How to Read the Psalms ")]), _vm._v("(IVP, 1987), and he gave me invaluable advice on how to organize the chapters of that book. I shudder to think that my commentary will be compared with his ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("incisive, tightly written, insightful work, though I dare to offer it with the hope that it might help those who want to understand, teach and preach this powerful collection of poems, songs and prayers.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("I also want to thank my best friend of the past forty-eight years (we met when we were thirteen), Dan Allender. Dan is a Christian psychologist who wants his counselling to be based on the Bible, and he has taught me more than anyone to read the Psalms as a ‘mirror of the soul’ (Calvin). Together we wrote "), _c('i', [_vm._v("Cry of the Soul ")]), _vm._v("(NavPress, 1994), a book which looks at our emotional lives through the prism of the Psalms. My work with Dan significantly prepared me to write this commentary.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("I also owe a debt of gratitude to Raymond Dillard (1944–1993), my teacher, mentor, friend and colleague, whose early death happened just over twenty years ago. He taught me to be honest with the text and, most importantly, to read the Old Testament in the spirit of Luke 24, in other words, Christologically. The reader will notice that, while honouring the original meaning of the text in its Old Testament context, I also offer a Christian reading of the psalm in the "), _c('i', [_vm._v("Meaning ")]), _vm._v("section of the commentary.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("I have taught the Psalms in many different institutions over the thirty-some years of my teaching career. Unfortunately, there are too many students, some of whom are now professors and ministers, to name, but I thank them for the influence they have had on me as we have interacted over the text of the Psalms.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("I do want to thank one institution in particular, namely Westmont College, where I am the Robert H. Gundry Professor of Biblical Studies. Westmont and its administration (particularly Gayle Beebe, the president, and Mark Sargent, the provost) have provided a wonderful environment for my writing and teaching. I could not be working at a better place.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("David Firth, the editor of the second edition of the Tyndale Old Testament Commentaries, has done a masterful job helping me write this commentary. I deeply appreciate his insight and also his aiding me to make this the best commentary I can offer. Of course, any errors remain my own.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("No-one loves the Psalms more than my wife Alice. She has not only memorized the entire book of Psalms, but she understands ")]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("them and appreciates them particularly as a witness to Christ. She has read my manuscript and deepened my reading of them. I dedicate this book to her.")])])]), _c('p', {
    staticClass: "sign"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Tremper Longman III"), _c('br'), _vm._v("Robert H. Gundry Professor of Biblical Studies"), _c('br'), _vm._v("Westmont College"), _c('br'), _vm._v("New Year’s Day 2014")])])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 69
// module chunks = 0